import { RacwaAuth } from "@racwa/react-adb2c";
import {
  BypassService,
  FeatureToggleProvider,
  RacwaInternalAuth,
  ShieldEnvironmentProvider,
  STORAGE_KEY_NPE_RACWA_CRM_ID,
} from "raci-react-library-npe";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { NPE_OAUTH_AUTHORITY, NPE_OAUTH_CLIENT_ID } from "./__NPE__/constants";
import { App as AppContent } from "./App";
import "./index.css";
import { ADB2C_CLIENT_ID, ADB2C_DOMAIN, ADB2C_TENANT } from "./shared/constants";

let App: any;
const racwaAuthProps = {
  domain: ADB2C_DOMAIN,
  tenant: ADB2C_TENANT,
  clientId: ADB2C_CLIENT_ID,
  strict: true,
};

/*
 ** WARNING: KNOW WHAT YOU'RE DOING BEFORE MAKING CHANGES TO
 ** TO THE BELOW IF STATEMENT
 ** UPON A BUILD, VITE WILL REMOVE CODE IN
 ** THE OUTPUTTED JAVASCRIPT FILE DEPENDING ON THE TARGET
 ** ENVIRONMENT
 ** THIS MEANS THAT FOR LOCAL/DEV/SIT BUILDS WILL INCLUDE
 ** AND SHIP CODE (YOU CAN SEE AND SEARCH FOR IN OUTPUTTED
 ** JAVASCRIPT ARTIFACTS) FOR MICROSOFT AUTHENTICATION LIBRARY
 */
if (
  import.meta.env.VITE_ENVIRONMENT === "LOCAL" ||
  import.meta.env.VITE_ENVIRONMENT === "DEV" ||
  import.meta.env.VITE_ENVIRONMENT === "SIT" ||
  import.meta.env.VITE_ENVIRONMENT === "UAT"
) {
  BypassService.setCrmIdFromQuerystring();
  BypassService.setShieldEnvironmentFromQuerystring();
  BypassService.setFeatureToggleFromQuerystring();
  BypassService.setSourceUrlFromQuerystring();

  // If the bypass CRM ID is set, use the App without the MyRAC auth component
  const AppInternal = sessionStorage.getItem(STORAGE_KEY_NPE_RACWA_CRM_ID)
    ? () => <AppContent />
    : () => (
        <RacwaAuth {...racwaAuthProps}>
          <AppContent />
        </RacwaAuth>
      );

  const featureToggles = JSON.parse(import.meta.env.VITE_FEATURE_TOGGLES ?? "[]");
  const environments = JSON.parse(import.meta.env.VITE_SHIELD_ENVIRONMENTS ?? "[]");

  const NpeApp = () => (
    <FeatureToggleProvider featureToggles={featureToggles}>
      <ShieldEnvironmentProvider environments={environments}>
        <AppInternal />
      </ShieldEnvironmentProvider>
    </FeatureToggleProvider>
  );

  if (import.meta.env.VITE_ENVIRONMENT !== "UAT") {
    App = () => (
      <RacwaInternalAuth
        clientId={NPE_OAUTH_CLIENT_ID}
        authority={NPE_OAUTH_AUTHORITY}
        redirectUri={
          import.meta.env.VITE_ENVIRONMENT === "LOCAL"
            ? window.location.origin
            : import.meta.env.BASE_URL.replace(/\/$/, "")
        }
      >
        <NpeApp />
      </RacwaInternalAuth>
    );
  } else {
    App = () => <NpeApp />;
  }
} else {
  App = () => (
    <RacwaAuth {...racwaAuthProps}>
      <AppContent />
    </RacwaAuth>
  );
}

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
